import LabelPart from './Label';
import Option from './Option';
import OptionsList from './OptionsList';
import Panel from './Panel';
import Positioner from './Positioner';
import Root from './Root';
import Trigger from './Trigger';
import TriggerButton from './TriggerButton';
import TriggerInput from './TriggerInput';
import SearchInput from './SearchInput';
import SelectPills from './SelectPills';
import HelperText from './HelperText';
import TriggerTagInput from './TriggerTagInput';

type SelectNS = {
	Root: typeof Root;
	Trigger: typeof Trigger;
	TriggerInput: typeof TriggerInput;
	Panel: typeof Panel;
	Option: typeof Option;
	Label: typeof LabelPart;
	HelperText: typeof HelperText;
	Positioner: typeof Positioner;
	SelectPills: typeof SelectPills;
	TriggerButton: typeof TriggerButton;
	OptionsList: typeof OptionsList;
	SearchInput: typeof SearchInput;
	TriggerTagInput: typeof TriggerTagInput;
};

export const Select = Object.assign({ Root } as SelectNS, {
	Root,
	Trigger,
	TriggerInput,
	Panel,
	Option,
	Label: LabelPart,
	HelperText,
	Positioner,
	SelectPills,

	TriggerButton,
	OptionsList,
	SearchInput,
	TriggerTagInput,
});
